export const setUrlToStorage = () => {
  const changeRecipeButton =
    document.querySelector('.js-diet.js-open-warning-modal') ||
    document.querySelector('.js-burger-menu-change-daily-recipes');

  if (changeRecipeButton) {
    changeRecipeButton.addEventListener('click', function () {
      const currentURL = window.location.href;
      localStorage.setItem('currentUrl', currentURL);
    });
  }
};

export const clearUrlFromStorage = () => {
  if (localStorage.getItem('currentUrl')) {
    localStorage.removeItem('currentUrl');
  }
};

document.addEventListener('DOMContentLoaded', () => {
  setUrlToStorage();
});
